/* eslint-disable no-nested-ternary */
import React from 'react';
import { PropTypes } from 'prop-types';
import colors from '@general/colors';

// either pass in a status or backgroundColor
const Circle = ({ children, size = 40, status, backgroundColor }) => {
    const backgroundColorFinal =
        status === 'success'
            ? colors.success
            : status === 'error'
            ? colors.error
            : status === 'warning'
            ? colors.warning
            : backgroundColor;
    return (
        <div
            style={{
                backgroundColor: backgroundColorFinal,
                borderRadius: '100%',
                display: 'flex',
                width: `${size}px`,
                height: `${size}px`,
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {children}
        </div>
    );
};

Circle.propTypes = {
    children: PropTypes.element,
    size: PropTypes.number,
    backgroundColor: PropTypes.string,
    status: PropTypes.oneOf(['success', 'warning', 'error']),
};

export default Circle;
